import { Palette } from '@mui/material/styles/createPalette';

export const getColorByIndex = (index: number) => {
    index = index % 15;
    const result = [
        'lime',
        'teal',
        'cyan',
        'pink',
        'purple',
        'red',
        'indigo',
        'deepPurple',
        'blue',
        'green',
        'lightGreen',
        'orange',
        'brown',
        'gray',
        'blueGrey'
    ];
    return result[index] as keyof Palette;
};
